export default "__VITE_ASSET__D$9_sJZi__"